module.exports = __webpack_public_path__ + "static/media/Icon_check.b78aff82.svg";